import React, { useContext, useEffect, useMemo } from 'react';
import Context from './context';
import { IdRoute } from '../../../../../types';
import useServiceReducer from '../../../../../shared/hooks/useServiceReducer';
import initialEsrsReducer from './initialEsrsReducer';
import { SpinnerArea } from '../../../../../shared/components';
import operInitialEsrsService from '../../../../../services/operInitialEsrsService';
import MainContext from '../../../../App/MainProvider/context';

const OperationProvider: React.FC<IdRoute> = ({ id, children }) => {
  const { inSuperUserMode, inGuidanceServiceMode } = useContext(MainContext);
  const [data, loading, , , loader, reload] = useServiceReducer(
    operInitialEsrsService.getFlow,
    initialEsrsReducer,
    parseInt(id, 10)
  );
  useEffect(() => {
    reload(parseInt(id, 10));
  }, [id, inSuperUserMode(), inGuidanceServiceMode()]);
  const value = useMemo(
    () => (data ? { data, loading, loader, reload } : null),
    [data, loading, loader, reload]
  );
  return (
    <SpinnerArea loading={loading}>
      {value && <Context.Provider value={value}>{children}</Context.Provider>}
    </SpinnerArea>
  );
};

export default OperationProvider;
